export const FEATURE_FLAGS = {
  AGENT_BOTS: 'agent_bots',
  AGENT_MANAGEMENT: 'agent_management',
  AUTO_RESOLVE_CONVERSATIONS: 'auto_resolve_conversations',
  AUTOMATIONS: 'automations',
  CAMPAIGNS: 'campaigns',
  CANNED_RESPONSES: 'canned_responses',
  CRM: 'crm',
  CUSTOM_ATTRIBUTES: 'custom_attributes',
  INBOX_MANAGEMENT: 'inbox_management',
  INTEGRATIONS: 'integrations',
  LABELS: 'labels',
  MACROS: 'macros',
  HELP_CENTER: 'help_center',
  REPORTS: 'reports',
  TEAM_MANAGEMENT: 'team_management',
  VOICE_RECORDER: 'voice_recorder',
  AUDIT_LOGS: 'audit_logs',
  INBOX_VIEW: 'inbox_view',
  SLA: 'sla',
  RESPONSE_BOT: 'response_bot',
  CHANNEL_EMAIL: 'channel_email',
  CHANNEL_FACEBOOK: 'channel_facebook',
  CHANNEL_TWITTER: 'channel_twitter',
  CHANNEL_WEBSITE: 'channel_website',
  CUSTOM_REPLY_DOMAIN: 'custom_reply_domain',
  CUSTOM_REPLY_EMAIL: 'custom_reply_email',
  DISABLE_BRANDING: 'disable_branding',
  EMAIL_CONTINUITY_ON_API_CHANNEL: 'email_continuity_on_api_channel',
  INBOUND_EMAILS: 'inbound_emails',
  IP_LOOKUP: 'ip_lookup',
  LINEAR: 'linear_integration',
  CAPTAIN: 'captain_integration',
  CUSTOM_ROLES: 'custom_roles',
  HIDE_PIPELINES_FOR_AGENT: 'hide_pipelines_for_agent',
  HIDE_SETTINGS_FOR_AGENT: 'hide_settings_for_agent',
  HIDE_CONVERSATION_CREATION_NOTIFICATION_FOR_AGENT:
    'hide_conversation_creation_notification_for_agent',
  HIDE_ASSIGNMENT_FOR_AGENT: 'hide_assignment_for_agent',
  DISABLE_AI_CORRECTIONS: 'disable_ai_corrections',
  HIDE_AI_CORRECTIONS_FOR_AGENT: 'hide_ai_corrections_for_agent',
  PIPELINE_ASSIGNED_ONLY_FOR_AGENT: 'pipeline_assigned_only_for_agent',
  WAVOIP: 'wavoip',
};
